// Resolves storage-relative URLs (e.g. "/api/media/abc") to absolute URLs
// using the configured backend host. External URLs and data URIs are passed through.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveMediaUrl = (url) => {
    if (!url) return "";
    if (/^(https?:|data:|blob:)/i.test(url)) return url;
    if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
    return url;
};
